import './App.css';
import Banner from './components/Banner/Banner';
import Footer from './components/footer/Footer';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import India from './components/offices/india/India';
import Canada from './components/offices/canada/Canada';
function App() {
  return (
    <>
      <Router>
        <Routes>
          <Route path='/' element={<><Banner/><Footer/></>}/>
          <Route path='/IndianOffice' element={<><India/><Footer/></>}/>
          <Route path='/CanadianOffice' element={<><Canada/><Footer/></>}/>
        </Routes>
      </Router>

      
    </>
  );
}

export default App;
